import { render } from "./aDownload.vue?vue&type=template&id=243a3478"
import script from "./aDownload.vue?vue&type=script&lang=js"
export * from "./aDownload.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__